import { push } from 'react-router-redux';

import * as api from '../../../common/api';

export function selectForOrder(workshopID) {
  return (dispatch) => {
    dispatch({
      type: 'ORDER_SELECT_WORKSHOP',
      payload: {
        id: workshopID
      }
    });

    dispatch(push('/objednavka/udaje'));
  };
}

export function submitOrder(values) {
  return (dispatch, getState) => {
    const workshopID = getState().order.selectedWorkshop;

    const order = {
      ...values,
      workshop_id: workshopID
    };


    const promise = async () => {
      const response = await api.post('/orders', { order });

      return response.status === 204;
    };

    dispatch({
      type: 'ORDER_SUBMIT',
      payload: promise()
    }).catch(() => null);

    dispatch(push('/objednavka/dekujeme'));
  };
}



// WEBPACK FOOTER //
// ./src/browser/Feature/order/actions.js